export default __webpack_public_path__ + "static/media/translation.7cec8319.png";